/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, InputLabel} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  minWidth: '400px',
  padding: theme.spacing(6),
  flexDirection: 'column',
  gap: theme.spacing(8),
  borderRadius: '32px',
  background: theme.palette.figma_surface?.main,
}));

export const InputsList = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
}));

export const InputRow = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: '150px 1fr',
  gap: theme.spacing(2),
}));

interface LabelWrapProps {
  maxWidth?: string;
  isFlexStart?: boolean;
}

export const LabelWrap = styled(InputLabel, {
  shouldForwardProp: prop => prop !== 'maxWidth' && prop !== 'isFlexStart',
})<LabelWrapProps>(({theme, maxWidth, isFlexStart}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  justifyContent: isFlexStart ? 'flex-start' : 'center',
  maxWidth: maxWidth || 'unset',

  '&.MuiFormLabel-root': {
    color: theme.palette.figma_gray_light_4?.main,
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '22px',
    overflow: 'visible',
    textOverflow: 'unset',
    whiteSpace: 'wrap',

    span: {
      color: theme.palette.figma_surface_muted?.main,
      fontSize: '14px',
      lineHeight: '16px',
    },
  },
}));

export const SubmitButton = styled(Button)(({theme}) => ({
  width: '100%',
  height: '56px',
  color: theme.palette.semantic_dark?.primary.on,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '28px',
  borderRadius: '8px',
  background: theme.palette.figma_primary?.dark,
  gap: theme.spacing(2),

  '&:hover': {
    background: theme.palette.figma_primary?.main,
  },

  '&.Mui-disabled': {
    background: '#4A4B4F',
    color: theme.palette.figma_gray_middle_dark?.dark,
  },
}));
